import React, { useState } from "react";
import InputMask from "react-input-mask";
import {toast} from "react-toastify";
import {formatDateToMMDDYYYY} from "../../../utils/Utils";
import './InputBox.scss';

const MaskInput = ({ label, value, question, error, placeHolder, onChange, mask, disabled = false }) => {

    const [inputValue, setInputValue] = useState(value);

    const onChangeInputText = (e) => {
        if(disabled) {
            toast.error("Report already ready can not change the response");
            return;
        }

        const value = e.target.value;
        setInputValue(value);
        onChange && onChange({ question: question, answerText: value });
    }

    const onBlurInput = (e) => {
        if(disabled) {
            toast.error("Report already ready can not change the response");
            return;
        }

        const value = e.target.value;
        setInputValue(value);
        onChange && onChange({ question: question, answerText: value });
    }

    return (
        <div className="inputbox__group inputbox__group--row">
            <label className="inputbox__col-form-label inputbox__label inputbox__label--horizontal inputbox__heading-primary">{label}</label>
            <div className="inputbox__col-xl-8 inputbox__col-lg-8">
                <InputMask
                    id={'input-box'}
                    mask={mask}
                    type="text"
                    autoComplete="off"
                    className="inputbox__text-input"
                    value={formatDateToMMDDYYYY(inputValue)}
                    placeholder={placeHolder}
                    onChange={onChangeInputText}
                    onBlur={(e) => onBlurInput(e)}
                    disabled={disabled}
                />
                {error && error.questionId === question.questionId && (
                    <span className="inputbox__text-muted inputbox__font-danger">* {error.message}</span>
                )}
            </div>
        </div>
    )
}

export default MaskInput;
